"use client";
import DynamicImage from "../DynamicImages/DynamicImage";
import BannerImage1 from "@/assets/images/static/leapIntoLuxury/ThermadorLILKitchenImages/LILKitchenImage1.png";
import BannerImage2 from "@/assets/images/static/leapIntoLuxury/ThermadorLILKitchenImages/LILKitchenImage2.png";
import BannerImage3 from "@/assets/images/static/leapIntoLuxury/ThermadorLILKitchenImages/LILKitchenImage3.png";
import BannerImage4 from "@/assets/images/static/leapIntoLuxury/ThermadorLILKitchenImages/LILKitchenImage4.png";

import BrandImage from "@/assets/images/static/leapIntoLuxury/Thermador.png";

import Link from "next/link";
import { useState, useEffect } from "react";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

const BannerData = [
  {
    src: BannerImage1,
  },
  {
    src: BannerImage2,
  },
  {
    src: BannerImage3,
  },
  {
    src: BannerImage4,
  },
];

const Card = ({ src }) => {
    return (
        <div className="rounded-[10px] overflow-hidden">
        <DynamicImage src={src} alt="img" />
        </div>
    );
  };

const Banner = () => {
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) return;

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  // Function to go to a specific slide when clicking a dot
  const goToSlide = (index) => {
    if (api) {
      api.scrollTo(index);
    }
  };
  return (
   
    <div className="pt-[45px] lg:pt-[40px]">
      <div className="flex flex-col items-center max-w-[545px] mx-auto px-5">
        <div className="mb-[46px] lg:mb-[22px]">
          <DynamicImage src={BrandImage} alt="brand-img" />
        </div>
        <h2 className="mb-[40px] text-[46px] text-[#242222] mob:max-w-[170px] mob:text-center mob:leading-[46px] mob:mb-[22px]">
          Leap Into Luxury
        </h2>
        <p className="text-[#000000] text-[15px] leading-[25px] text-center font-medium mb-[26px] lg:text-[14px] mob:max-w-[322px] mob:font-normal ">
          Whether you&apos;re a first time homeowner, newlywed, or just
          replacing an existing appliance, our high-end Leap into Luxury kitchen
          packages provide the exceptional craftsmanship and innovation
          Thermador is renowned for, while fitting into your budget.{" "}
        </p>
        <div className="flex gap-[25px] flex-wrap justify-center mob:gap-[22px]">
          <Link
            href="/kitchen-packages?page=1&brandIds=3"
            className="text-[#242222] min-h-[38px] text-center inline-flex py-[9px] text-[12px] rounded-[39px] px-[15px] border border-[#242222]"
          >
            Shop All Thermador Packages
          </Link>
          <Link
            href="https://kitchenplanner.thermador.com/airport-home-appliance/"
            className="text-[#242222] min-h-[38px] text-center inline-flex py-[9px] text-[12px] rounded-[39px] px-[15px] border border-[#242222]"
          >
            Create a Kitchen Package
          </Link>
        </div>
      </div>
      <div className="max-w-[1440px] px-[20px] mx-auto mt-[80px] lg:mt-[42px] mob:px-0">
        <Carousel
          opts={{ align: "start" }}
          className="w-full pb-6"
          setApi={setApi}
        >
          <CarouselContent className="m-0">
            {BannerData.map((product, index) => (
              <CarouselItem
                key={index}
                className="basis-full m-0"
              >
                <div className="rounded-[10px] overflow-hidden mob:rounded-none">
                <DynamicImage src={product.src} alt="img" className="min-h-[196px]" />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          {api?.scrollSnapList()?.length > 1 && (
            <div className=" grid grid-cols-[1fr_auto] lg:grid-cols-[1fr_auto] items-center gap-3 lg:pl-2">
              {/* Clickable Pagination Dots */}
              <div className="flex justify-center ">
                {Array.from({ length: count }).map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`w-full h-1  transition-all ${
                      current === index + 1 ? "bg-black" : "bg-[#D0D0D0]"
                    }`}
                  />
                ))}
              </div>
              {/* Navigation Buttons */}
              <div className="flex items-center justify-end gap-3">
                <CarouselPrevious className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
                <div className="text-sm text-[#0C2340] font-medium">
                  {current}/{count}
                </div>
                <CarouselNext className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
              </div>
            </div>
          )}
        </Carousel>
      </div>
    </div>
  );
};

export default Banner;